import { StrategyLabels } from '~/types';

export const strategyOptions = Object.entries(StrategyLabels).map(
  ([key, value]) => ({
    id: Number(key),
    name: value,
  }),
);
